import { baseUrl, requestHeader } from '../../config';
import Axios from 'axios';
import { CatchReturnError } from "./actionHandler";
// requestHeader.Authorization = localStorage.getItem('saw-token') || ""
export const getManualAppraisals = (filters: { page: number, limit: number, search: string, sortBy: string, sortType: string }) => {
    let URL = baseUrl + `/manualAppraisal?search=${filters.search}&limit=${filters.limit}&page=${filters.page}
    &sortBy=${filters.sortBy}&sortType=${filters.sortType}`
    return Axios.get(URL, requestHeader).then(res => {
        return res["data"]
    }).catch(err => {
        CatchReturnError(err)
    })
}
export const getManualAppraisalCount = () => {
    return Axios.get(baseUrl + '/manualAppraisal/count', requestHeader).then(res => {
        return res["data"]
    }).catch(err => {
        CatchReturnError(err)
    })
}
export const createManualAppraisals = (payload: { domainName: string, manualValue: number }) => {
    return Axios.post(baseUrl + '/manualAppraisal', payload, requestHeader).then(response => {
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}
export const patchManualAppraisals = (UID: string, payload: { domainName?: string, manualValue?: number }) => {
    return Axios.patch(baseUrl + '/manualAppraisal/' + UID, payload, requestHeader).then(response => {
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}

export const delManualAppraisals = (UID: string) => {
    return Axios.delete(baseUrl + '/manualAppraisal/' + UID, requestHeader).then(res => {
        let response = res['data']
        return response
    }).catch(err => {
        CatchReturnError(err)
    })
}